import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { useMediaQuery } from '@material-ui/core';
import { BREAKPOINTS } from 'src/utils/constants';
import usePostListing from 'src/hooks/api/listings/usePostListing';
import { FormikValues } from 'formik';
import Steps from '../Common/Steps';
import CategoryDetails from './components/Steps/CategoryDetails';
import ListingDetails from './components/Steps/ListingDetails';
import UploadImages from './components/Steps/UploadImages';

const Container = styled.div``;
const StyledSteps = styled(Steps)<any>`
  background-color: white;
  margin: ${({ isMobile }) => (isMobile && '0') || '5%'};
  padding: ${({ isMobile }) => (isMobile && '0') || '5%'};
`;
const steps: Array<any> = [CategoryDetails, ListingDetails, UploadImages];

type TProps = {};
const PostListings: React.FC<TProps> = () => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE);
  const { postListing } = usePostListing();
  const router = useRouter();

  const handleSubmit = async ({
    isLastStep,
    handleNext,
    values,
  }: {
    isLastStep: boolean;
    handleNext: () => void;
    values: FormikValues;
  }) => {
    if (!isLastStep) {
      handleNext();
    } else {
      await postListing(values);
      router.push('/dashboard/userlistings');
    }
  };

  return (
    <Container>
      <StyledSteps isMobile={isMobile} StepsComp={steps} SubmitHandler={handleSubmit} />
    </Container>
  );
};

export default PostListings;
